import styled from '@emotion/styled';

import { Color } from '../../../../Theme';

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
  user-select: none;
`;

const TimeRange = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 1rem;

  > * {
    width: 100%;
  }
`;

const DatePickerWrapper = styled.div`
  display: flex;
  position: absolute;
  z-index: 101;
  border: 1px solid ${Color.grey03};
  border-radius: 0.75rem;
  flex-direction: column;
  width: 688px;
  margin-top: -1px;
  overflow: hidden;
`;

const StyledSubmitButton = styled.button`
  color: ${Color.text};
  background-color: ${Color.white};
  border: 0;
  padding: 1rem;
  text-align: right;
`;

export { Backdrop, TimeRange, DatePickerWrapper, StyledSubmitButton };
